const RED = 'rgb(187, 14, 61)';
const LIGHT_GREY = 'rgb(149, 149, 149)';
const BLACK = 'rgb(43, 43, 43)';
const BLUE = 'rgb(66, 133, 244)';
const PINK = '#e17ac1';
const TEAL = '#28becd';
const SECONDARY_BLUE = '#2578b2';
const PURPLE = '#936abb';
const SECONDARY_RED = '#b32237';
const ORANGE = '#fd7f28';
const GREEN = '#368a2a';
const DARK_GREY = '#4c4c4c';

const SECONDARY = RED;
const DISABLED = LIGHT_GREY;

export {
  BLACK,
  BLUE,
  DARK_GREY,
  DISABLED,
  GREEN,
  ORANGE,
  PINK,
  PURPLE,
  SECONDARY,
  SECONDARY_BLUE,
  SECONDARY_RED,
  TEAL,
};
